module.exports = __webpack_public_path__ + "img/WebPOS.3beba4f3.png";